import React, { Component } from 'react';
import Icon from '../Icon/Icon';
require('./Contact.scss');
class Contact extends Component {
    render() {
        return (
            <div>
                <h2 className="Heading Heading--xs Heading--light Heading--uppercase Heading--strong">Contact</h2>
                <address className="Text Text--plain">
                    <a href="mailto:info@magiccardbuyer.eu" className="Link Link--plainHoverBranded Link--noUnderline">
                        <Icon key="info@magiccardbuyer.eu" title="info@magiccardbuyer.eu" classes="Icon--branded Icon--spacedRight Icon--medium Icon--disabled" icon="ion ion-ion-ios-email-outline" />
                        info@magiccardbuyer.eu
                    </a><br />
                    magiccardbuyer.eu<br />
                    Ondrickova 2166/14<br />
                    130 00 Prague<br />
                    Czech Republic<br />
                    <a href="https://www.google.cz/maps/place/Ond%C5%99%C3%AD%C4%8Dkova,+130+00+Praha+3/@50.0805176,14.4501952,17z/data=!3m1!4b1!4m5!3m4!1s0x470b949c4b6cc565:0x13636034ecb17abc!8m2!3d50.0805176!4d14.4523839" className="Link Link--plainHoverBranded Link--noUnderline" target="_blank">
                        <Icon key="Show on map" title="Show on map" classes="Icon--branded Icon--spacedRight Icon--medium Icon--disabled" icon="ion ion-ion-android-pin" />
                        Show on map
                    </a><br />
                </address>
            </div>
        );
    }
}
export default Contact;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/Contact.js
 **/